import React from "react";
import styled from "styled-components";
import CaseStudyHeading from "../CaseStudiesHeading";
import { codeReminders } from "../data";
import CaseStudiesCard from "../CaseStudiesCard";
import Heading from "../../../Heading";
import Box from "../../../Box";
import Rule from "../../../Rule";
import NoHooks from "../../../../img/noHooks.png";
import Hooks from "../../../../img/hooks.png";
import BlogLayout from "../BlogLayout";

const CodeElementBlock = styled.section`
  display: block;
  width: 100%;
  padding: var(--spacing-small);
  background: #00000069;
  border-radius: var(--radius-card);
  margin-bottom: var(--spacing-clear);
  border: 1px solid #ffffff1f;
`;

const CodeElement = styled.code`
  margin-bottom: var(--spacing-small);
  display: block;
  &:last-child {
    margin-bottom: var(--spacing-clear);
  }
  &:empty {
    display: none;
  }
`;

const ImgElementBlock = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: var(--spacing-large);
  width: 100%;
  background: none;
  border-radius: var(--radius-card);
  margin-bottom: var(--spacing-clear);
  margin-top: var(--spacing-x-large);
`;

const ImgElement = styled.img`
  margin-bottom: var(--spacing-small);
  display: block;
  width: 100%;
  padding: var(--spacing-small);
  background: #2b273d;
  border-radius: 12px;
  border: 1px solid #ffffff1f;
  &:last-child {
    margin-bottom: var(--spacing-clear);
  }
`;

const ParagraphElement = styled.p`
  max-width: 64ch;
`;

const CodeReminders = () => {
  return (
    <React.Fragment>
      <CaseStudyHeading title="Code Reminders" />
      {codeReminders.map((content) => (
        <CaseStudiesCard spacing="large" key={content.id}>
          <Heading
            variant="smaller"
            style={{ marginTop: 0, marginBottom: "var(--spacing-x-tiny)", textTransform: "uppercase" }}
          >
            Snippets
          </Heading>
          <p style={{ marginBottom: 0, fontSize: "var(--font-size-text-medium)" }}>
            Practical code snippets demonstrating React and design system usage.
          </p>
          <Rule spacing="medium" inverted mt="var(--spacing-medium)" mb="var(--spacing-large)" />
          <BlogLayout>
            <Heading variant="larger" mb="0">
              {content.title}
            </Heading>
            <p>{content.description}</p>
            <CodeElementBlock>
              <CodeElement>{content.example.comment}</CodeElement>
              <CodeElement>{content.example.code}</CodeElement>
            </CodeElementBlock>
          </BlogLayout>
        </CaseStudiesCard>
      ))}
      <CaseStudiesCard spacing="large">
        <Heading
          variant="smaller"
          style={{ marginTop: 0, marginBottom: "var(--spacing-x-tiny)", textTransform: "uppercase" }}
        >
          Reminder
        </Heading>
        <p style={{ marginBottom: 0, fontSize: "var(--font-size-text-medium)" }}>
          A reminder of how to use React Hooks effectively.
        </p>
        <Rule spacing="medium" inverted mt="var(--spacing-medium)" mb="var(--spacing-large)" />

        <BlogLayout>
          <Heading variant="larger">Handling state in React</Heading>
          <ParagraphElement>
            Previously if you needed to access state in your component, you would need to utilise a class component and
            add additional code to initialise state with the constructor. With the introduction of React Hooks, you can
            use your function-based components and keep your code lean and straightforward.
          </ParagraphElement>

          <ImgElementBlock>
            <Box marginBottom="clear">
              <Heading variant="medium" style={{ marginBottom: 0 }}>
                Old
              </Heading>
              <p>Handle state with the constructor method.</p>
              <ImgElement src={NoHooks} />
            </Box>
            <Box marginBottom="clear">
              <Heading variant="medium" style={{ marginBottom: 0 }}>
                New
              </Heading>
              <p>Handle state with Hooks.</p>
              <ImgElement src={Hooks} />
            </Box>
          </ImgElementBlock>
        </BlogLayout>
      </CaseStudiesCard>
    </React.Fragment>
  );
};

export default CodeReminders;
